// Width of the Y axis area in all the charts on the metrics page.
export const YAXIS_WIDTH = 100; // px
